/* encapsulates all jQuery-related functionality necessary for the MVC unobtrusive validation framework */

import jQuery from "jquery";

import "jquery-validation";
import "jquery-validation-unobtrusive";

export const setupjQuery = () => {
    // expose jQuery to allow validator to be manipulated
    window["$"] = window["jQuery"] = jQuery;

    if ($) {
        // set "ignore" to empty, forcing validation of hidden fields
        // see https://stackoverflow.com/a/8565769
        $.validator.setDefaults({
            ignore: []
        });
    }
};